var React = require('react');

function Biking (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm80 64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92L396 217a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64z","className":"fa-primary","key":2})]);
}

Biking.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Biking;

Biking.default = Biking;
